import ROLES from '../../models/roles';

class RoleService {
  constructor(localStorageService, $state) {
    this.localStorageService = localStorageService;
    this.$state = $state;
  }

  setRole(role) {
    this.localStorageService.set('role', role);
  }

  setIsImpersonating(isImpersonating) {
    this.localStorageService.set('isImpersonating', isImpersonating);
  }

  getRole() {
    let roleString = this.localStorageService.get('role');
    return Number(roleString);
  }

  looksLikeCustomerAdmin() {
    let role = this.getRole();
    let isImpersonating = this.getIsImpersonating();

    return (role === ROLES.CUSTOMER_ROLE || isImpersonating);
  }

  looksLikeAdminAsCustomer() {
    let role = this.getRole();
    let isImpersonating = this.getIsImpersonating();

    return (role !== ROLES.CUSTOMER_ROLE && isImpersonating);
  }

  getIsImpersonating() {
    return this.localStorageService.get('isImpersonating');
  }

  getRoleFieldValue(field) {
    let role = this.getRole();
    let isImpersonating = this.getIsImpersonating();
    return isImpersonating ? ROLES[ROLES.CUSTOMER_ROLE][field] : ROLES[role][field];
  }

  isUnManagedCustomer() {
    return this.getIsImpersonating() && this.localStorageService.get('impersonatingCustomer') && this.localStorageService.get('impersonatingCustomer').rosterType === 'Manual';
  }

  isAuthorized(stateName) {
    let state = this.$state.get(stateName);
    let role = this.getRole();
    let isImpersonating = this.getIsImpersonating();
    let hasValidRole = false;

    if(state.roleRequired) {
      hasValidRole = state.roleRequired.indexOf(role) > -1;
    }

    // dirty check but the whole router valid need revamping
    if(stateName === 'home.syncSettings' && this.isUnManagedCustomer()) {
      return role === ROLES.SUPER_ADMIN;
    } else {
      return (!state.roleRequired || hasValidRole || isImpersonating);
    }
  }
}

RoleService.$inject = ['localStorageService', '$state'];

export default RoleService;



// WEBPACK FOOTER //
// ./app/common/role/role.service.js